import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionSchedulePhase} from '@domain/production-schedule/production-schedule-phase.enum';
import {BidirectionalMap, EnumUtils, ObjectUtils} from '@vdw/angular-component-library';

@Component({
  selector: 'app-production-schedule-progress',
  templateUrl: './production-schedule-progress.component.html',
  styleUrls: ['./production-schedule-progress.component.scss']
})
export class ProductionScheduleProgressComponent implements OnInit {
  private static readonly widthPerPhaseInPx = 80;
  @Input() public productionSchedule: ProductionSchedule;
  @Input() public productionSchedulePhase: ProductionSchedulePhase;
  @Input() public isScheduleCompleted: boolean;
  @Input() public areAllFieldsDisabled: boolean = false;
  @Output() public clickEvent = new EventEmitter<ProductionSchedulePhase>();
  @ViewChild('phase') public phase: ElementRef;

  public get productionSchedulePhases(): ProductionSchedulePhase[] {
    return EnumUtils.getEnumValues(ProductionSchedulePhase).filter(
      (phase: ProductionSchedulePhase) => this.productionSchedulePhaseOrderMap.getValue(phase) < this.productionSchedulePhaseOrderMap.getValue(ProductionSchedulePhase.COMPLETE)
    ) as ProductionSchedulePhase[];
  }

  private readonly productionSchedulePhaseOrderMap = new BidirectionalMap<ProductionSchedulePhase, number>([
    [ProductionSchedulePhase.PRESELECTION, 0],
    [ProductionSchedulePhase.CONFIGURE, 1],
    [ProductionSchedulePhase.BUILD, 2],
    [ProductionSchedulePhase.VERIFY, 3],
    [ProductionSchedulePhase.COMPLETE, 4]
  ]);

  public ngOnInit(): void {
    if (this.isScheduleCompleted) {
      this.phase.nativeElement.style = 'default';
    }
  }

  public canHoverOverItem(phase: ProductionSchedulePhase): boolean {
    return (
      ((this.isScheduleCompleted || this.areAllFieldsDisabled) && phase !== ProductionSchedulePhase.CONFIGURE && phase !== ProductionSchedulePhase.VERIFY) || phase === this.productionSchedulePhase
    );
  }

  public getWidthOfActiveTrack(): string {
    let result = `${this.productionSchedulePhaseOrderMap.getValue(this.productionSchedulePhase) * ProductionScheduleProgressComponent.widthPerPhaseInPx}px`;

    if (!ObjectUtils.isDeepEqual(this.productionSchedule, this.productionSchedulePhases[this.productionSchedulePhases.length - 1])) {
      const nextPhase = this.productionSchedulePhaseOrderMap.getValue(this.productionSchedulePhase) + 1;
      if (this.isActivePhase(this.productionSchedulePhaseOrderMap.getKey(nextPhase))) {
        result = `${nextPhase * ProductionScheduleProgressComponent.widthPerPhaseInPx}px`;
      }
    }

    return result;
  }

  public isActivePhase(phase: ProductionSchedulePhase): boolean {
    return this.productionSchedulePhaseOrderMap.getValue(phase) <= this.productionSchedulePhaseOrderMap.getValue(this.productionSchedulePhase);
  }

  public isCurrentPhase(phase: ProductionSchedulePhase): boolean {
    return this.productionSchedulePhaseOrderMap.getValue(phase) === this.productionSchedulePhaseOrderMap.getValue(this.productionSchedulePhase);
  }

  public getPhaseTranslationKey(phase: ProductionSchedulePhase): string {
    return `PRODUCTION_ORDER.PHASES.${ProductionSchedulePhase[phase]}`;
  }

  public getIconForPhase(phase: ProductionSchedulePhase): string {
    return ProductionSchedulePhase.getIcon(phase);
  }

  public phaseClicked(phase: ProductionSchedulePhase): void {
    if (
      (!this.isScheduleCompleted && !this.areAllFieldsDisabled) ||
      ((this.isScheduleCompleted || this.areAllFieldsDisabled) && (phase === ProductionSchedulePhase.CONFIGURE || phase === ProductionSchedulePhase.VERIFY))
    ) {
      this.clickEvent.emit(phase);
    }
  }
}
